var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90196 0.5C10.7138 0.5 13.8039 3.59011 13.8039 7.40196C13.8039 8.21063 13.6644 8.99811 13.3991 9.7367L11.8591 8.19623C11.9002 7.93753 11.9216 7.67224 11.9216 7.40196C11.9216 4.62971 9.67421 2.38235 6.90196 2.38235C4.12971 2.38235 1.88235 4.62971 1.88235 7.40196C1.88235 10.1742 4.12971 12.4216 6.90196 12.4216C8.62927 12.4216 10.1528 11.5491 11.0559 10.2208L12.404 11.5697C12.4035 11.5703 12.403 11.571 12.4025 11.5716L15.7243 14.8933C16.0919 15.2609 16.0919 15.8568 15.7243 16.2243C15.3568 16.5919 14.7609 16.5919 14.3933 16.2243L11.0716 12.9025C9.88195 13.8059 8.42978 14.3039 6.90196 14.3039C3.09011 14.3039 0 11.2138 0 7.40196C0 3.59011 3.09011 0.5 6.90196 0.5Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.65ae89df6c07b2e8f1eba479e07b6856.svg";
export { ForwardRef as ReactComponent };